module.exports = "pegasus/assets/email1-column-8.png";